export default "__VITE_ASSET__CUpXbpNK__"